<template>
<div class="page">
  <el-tabs v-model="activeTab" class="tabs">
    <el-tab-pane label="周目标" name="week">
      <WeekPage v-if="visitedTabs.week" :users="users" />
    </el-tab-pane>
    <el-tab-pane label="月目标" name="month">
      <MonthPage v-if="visitedTabs.month" :users="users" />
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { Vue, Component, Mixins } from 'vue-property-decorator';
import MonthPage from './month';
import WeekPage from './week';
import Utils from '@/components/utils.vue';
import _ from 'lodash';

@Component({
  components: {
    MonthPage,
    WeekPage,
  }
})
export default class Page extends Mixins(Vue, Utils) {
  activeTab = 'week';
  visitedTabs = {
    week: true, // 默认激活的 tab 立即加载
    month: false,
  };
  users = [];

  created() {
    // 监听 activeTab 变化
    this.$watch('activeTab', (newTab) => {
      this.$set(this.visitedTabs, newTab, true);
    }, { immediate: true });
  }

  async fetchUsers() {
    const users = await this.$request.get('/users/read_options', {
      page: 0,
      ...this.userOptionsFilter,
      id_eq: this.roleKind === 'salesman' || this.roleKind === 'customer_service' ? this.currentUser.id : undefined, // 业务员只能看自己的业绩
    });
    this.users = _.orderBy(users, user => {
      if (this.currentUser.id === user.id) {
        return 0;
      }
      return 1;
    });
  }

  mounted() {
    this.fetchUsers();
  }
}

export const route = [
  {
    path: '/performance_goals',
    name: 'performance_goals.index',
    component: Page,
    meta: {
      can: 'performance_goals.read',
      title: '业绩目标',
    }
  },
]
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  padding: 0 15px;

  .tabs {
    height: 100%;
    display: flex;
    flex-direction: column;

    ::v-deep .el-tabs__content {
      flex: 1;
      overflow: hidden;
    }

    ::v-deep .el-tab-pane {
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>
